<template>
	<div class="box">
		<arrorImg bg="white"></arrorImg>
		<navBar title="优惠券" color="#ffffff"></navBar>
		<div class="title-recharge">
			<div v-for="(item,index) in title" :key="index"><span :class="isEffective==index?'active':''"
					@click="changeCharge(index)">{{item}}</span></div>
		</div>
			<div class="content-box">
				<div class="content-list" v-if="!isEmpaty">
					 <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
					<li class="list-item" v-for="(item,index) in List" :key="index">
						<div class="conpon-item" :class="isEffective==1?'conpon-default':''">
							<div>
								<span class="conpon-yuan">￥</span><span class="conpon-text">{{item.reduceMoney}}</span>
								<div class="counpon-center">
									<span class="conpon-count">满{{item.fullMoney}}可用</span>
									<span class="conpon-time">有效期至{{item.expireTime}}</span>
								</div>
							</div>
							<span class="conpon-btn" v-if="isEffective==0" @click="routeCharge(item)">去使用</span>
							<span class="conpon-btndefault" v-if="isEffective==1&&item.overdueState==1">已使用</span>
							<span class="conpon-btndefault" v-if="isEffective==1&&item.overdueState==2">已过期</span>
						</div>
						<img v-if="isEffective==0&&item.overdueState==1" src="../../../static/couponed_icon.png" alt="">
					</li>
					 </ul>
					<div class="load-more">
						 <span>{{ !isLoading ?'加载中':loadingText }}</span>
					</div>
				</div>
				<div class="no-log" v-else>
					<img src="../../../static/no-log.png" alt="">
					<span>暂无记录~</span>
				</div>
				
			</div> 
	</div>
</template>
<script>
import {Toast, MessageBox } from "mint-ui";
	import arrorImg from "../../components/arrow-img.vue";
	import navBar from '../components/navbar.vue'
	export default {
		components: {
			arrorImg,
			navBar
		},
		data() {
			return {
				loading:false,
				title: ['可用', '失效'],
				List: [],
				pageNo: 1,
				pageSize: 8,
				isEffective: 0,
				pageCount: 1,
				isLoading:false,
				loadingText: '没有更多了',
				isEmpaty: false,
				isEntranceData:'',
				pageType:''
			}
		},
		mounted() {
			
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData;
			}
			
			if(this.$route.query.pageType){
				this.pageType=this.$route.query.pageType;
			}
			var openid =  this.$base.getStorage('openid')
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			    var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// #endif
			} else if(isWxAuthorized==0&&city==1&&openid&&!this.$store.state.user.isSNS){
				 this.$base.setStorage('isSNS',true)
				this.$store.state.user.isSNS=true;
				this.$commonApi.snsapiUserinfo();
				this.findUserCouponsList()
				this.insertPageAccessData();
			
			} else {
				this.findUserCouponsList()
				this.insertPageAccessData();
			
			}
			// this.$commonApi.share();

		},
		beforeRouteEnter(to, from, next) {
				if(to.name == 'bookCharge'){ // 当从上个页面chooseCoupons返回当前页面时，不刷新当前页面
					to.meta.keepAlive = false;
				}
			console.log(to)
				next();
			},
		methods: {
				  loadMore() {
		this.loading = true;
         if (this.pageCount > this.pageNo) {
          this.pageNo += 1;
          this.findUserCouponsList();
        } else {
          	this.loading = false;
          this.loadingText = "没有更多了";
        }
		},

			insertPageAccessData() {
				var pageName='';
				if(this.pageType=='bookMine'){
					pageName='我的'
				}else if (this.pageType === "bookCurrency") {
					pageName = "书币";
      }else if (this.pageType === "bookCharge") {
        pageName = "充值中心";
      } else if (this.pageType === "bookCity") {
        pageName = "书城";
      } 
				   var params = {
				       pageName: '我的优惠券',
				       pageRemark: '上级页面：'+pageName,
					   isEntranceData:this.isEntranceData
				     }
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
			routeCharge(item){
				this.$router.push({
					path:'/pages/bookCharge/index',
					query:{
						pageType:'userCoupons',
						couponId:item.id
					}
				})
			},
			changeCharge(index) {
				this.isEffective = index;
				this.pageNo = 1;
				this.List=[];
				this.findUserCouponsList()
			},
			findUserCouponsList() {
				var params = {
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					isEffective: this.isEffective //0有效，1无效
				}
				this.isLoading=false;
				this.$api.findUserCouponsList(params).then(res => {
					if (res.status == 1) {
						this.pageCount = res.pages;
						if (this.pageNo == 1) {
							this.List = res.data;
							if (this.pageCount <= 1) {
								this.loadingText = '没有更多了'
							} else {
								this.loadingText = '加载中...'
							}
						} else {
							this.List = this.List.concat(res.data)
						}
						if (this.List.length == 0) {
							this.isEmpaty = true;
						} else {
							this.isEmpaty = false;
						}
							this.isLoading=true;

					}
				})
			}

		}
	}
</script>

<style scoped>
	.box{
		min-height: 100%;
		background-color: #F3F3F3;
			/* height:calc(48px + env(safe-area-inset-bottom)); */
			  padding-bottom: constant(safe-area-inset-bottom);
			/* 兼容 iOS < 11.2 */
			padding-bottom:env(safe-area-inset-bottom);
			/* 兼容 iOS >= 11.2 */
			/* box-sizing: content-box; */
	}
	.title-recharge {
		display: flex;
		border-top: 1px solid #F3F3F3;
		background-color: #FFFFFF;
		position: fixed;
		left: 0px;
		top: calc(44px + env(safe-area-inset-top));
		width: 100%;
		z-index: 99;
	}

	.title-recharge>div {
		width: 50%;
		flex: 1;
		text-align: center;
		padding-top: 12px;
		padding-bottom: 10px;
	}

	.title-recharge span {
		font-size: 16px;
		color: #AAAAAA;
		padding-bottom: 4px;
		border-bottom: 3px solid #FFFFFF;
	}

	.title-recharge span.active {
		color: #333333;
		border-bottom: 3px solid #333333;
	}

	.content-list {
		padding: 44px 16px;
		margin-top: 24px;
	}
	.content-box{
		margin-top:calc(68px + env(safe-area-inset-top));
	}

	.list-item {
		background-image: url(../../../static/coupon_bg.png);
		position: relative;
		background-repeat: no-repeat;
		background-size: cover;
		padding: 24px;
		padding-right: 16px;
		box-sizing: border-box;
		margin-bottom: 16px;
		border-radius: 12px;
	}

	.list-item>img {
		width: 40px;
		height: 38px;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.conpon-item {
		display: flex;
		justify-content: space-between;
	}

	.conpon-item>div {
		display: flex;
	}

	.counpon-center>span {
		display: block;
		margin-left: 7px;
	}

	.conpon-yuan {
		font-size:14px;
		color: #de3b34;
		line-height: 40px;
	}

	.conpon-text {
		font-size: 28px;
		color: #de3b34;
		font-weight: bold;
		width: 48px;
	}

	.conpon-count {
		font-size: 16px;
		font-weight: bold;
		color: #333333;
	}

	.conpon-time {
		font-size: 11px;
		color: #aaaaaa;
		margin-top: 3px;
	}
	.conpon-btn {
		background-color: #de3b34;
		border-radius: 12px;
		width: 58px;
		height: 24px;
		font-size: 12px;
		text-align: center;
		line-height: 24px;
		color: #ffffff;
		margin-top: 10px
	}

	.conpon-default>div>.conpon-yuan,
	.conpon-default>div>.conpon-text,
	.conpon-default>div>div>.conpon-count {
		color: #aaaaaa;
	}

	.conpon-btndefault {
		font-size: 12px;
		color: #aaaaaa;
		margin-top: 10px;
	}

	.load-more {
		text-align: center;
		  font-size: 12px;
color: #AAAAAA;
   padding: 16px 0px;
	}

	.no-log {
		text-align: center;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.no-log img {
		width: 128px;
		height: 128px;
		display: block;
		margin: 0 auto;

	}
	.no-log span {
		display: block;
		font-size: 14px;
		color: #666666;
		margin-top: 20px;
	}
	

</style>



// WEBPACK FOOTER //
// src/view/userCoupons/index.vue